export default __webpack_public_path__ + "static/media/Wolf's Hood of the Grasping Wild.07b3ca0d.jpg";